import {
  useProfileSummary,
  DefaultAvatar,
  ProfileStats,
  saveProfilePhoto,
} from "../../../components/ProfileSummary/index.jsx";
import {
  useTaskBonusTotals,
  getTaskBonusPeriod,
} from "../../../hooks/useTaskBonusTotals.js";
import { ProfileBadges } from "../../../components/ProfileSummary/index.jsx";
import { ProfileBalances } from "../../../components/ProfileSummary/index.jsx";
import { ProfileAvatarPicker } from "../../../components/ProfileSummary/index.jsx";
import React, { useState, useCallback, useMemo } from "react";
import api from "../../../services/api";
import { ANOS } from "../../../shared/constants";
import {
  fmtDate,
  fmtNum,
  iniMes,
  iniSemana,
  todayISO,
} from "../../../shared/utils";
import { sourceImage } from "../../../utils/source-image";
import { isAulaConcluida } from "../Conteudos/progressUtils";
const MERIT_ICON_BY_CATEGORY = {
  horas: "clock",
  questões: "book",
  resumos: "doc",
  streak: "zap",
  pontos: "star",
  social: "users",
  desafios: "trophy",
};
const MERIT_ICON_BY_TYPE = {
  horas_total: "clock",
  horas_semana: "clock",
  questões_total: "book",
  questões_semana: "book",
  resumos_total: "doc",
  streak: "zap",
  checkpoints_total: "check",
  pontos_total: "star",
  indicacoes_total: "users",
  desafios_vencidos: "trophy",
  videoaula_total: "play",
};
function resolveMeritIconName(merit) {
  const explicit = String(merit?.icone || "").trim();
  if (explicit && explicit !== "*" && explicit.length > 1) return "custom";
  return (
    MERIT_ICON_BY_CATEGORY[merit?.cat] ||
    MERIT_ICON_BY_TYPE[merit?.tipo] ||
    "medal"
  );
}
function MeritGlyph({ name, size = 20, customText }) {
  const common = {
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
  };
  if (name === "custom") return <span>{customText}</span>;
  if (name === "clock") {
    return (
      <svg {...common}>
        <circle cx="12" cy="12" r="9" />
        <path d="M12 7v5l3 2" />
      </svg>
    );
  }
  if (name === "book") {
    return (
      <svg {...common}>
        <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" />
        <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z" />
      </svg>
    );
  }
  if (name === "doc") {
    return (
      <svg {...common}>
        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
        <path d="M14 2v6h6" />
      </svg>
    );
  }
  if (name === "zap") {
    return (
      <svg {...common}>
        <path d="M13 2L3 14h7l-1 8 10-12h-7z" />
      </svg>
    );
  }
  if (name === "users") {
    return (
      <svg {...common}>
        <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
        <circle cx="8.5" cy="7" r="4" />
        <path d="M20 8v6" />
        <path d="M23 11h-6" />
      </svg>
    );
  }
  if (name === "trophy") {
    return (
      <svg {...common}>
        <path d="M8 21h8" />
        <path d="M12 17v4" />
        <path d="M7 4h10v3a5 5 0 0 1-10 0z" />
        <path d="M5 7H3a2 2 0 0 0 2 2" />
        <path d="M19 7h2a2 2 0 0 1-2 2" />
      </svg>
    );
  }
  if (name === "check") {
    return (
      <svg {...common}>
        <circle cx="12" cy="12" r="9" />
        <path d="M8 12l3 3 5-6" />
      </svg>
    );
  }
  if (name === "play") {
    return (
      <svg {...common}>
        <circle cx="12" cy="12" r="9" />
        <path d="M10 8l6 4-6 4z" />
      </svg>
    );
  }
  return (
    <svg {...common}>
      <path d="M12 2l3 6 6 .9-4.5 4.4 1 6.2L12 17l-5.5 2.5 1-6.2L3 8.9 9 8z" />
    </svg>
  );
}
function MeritIcon({ merit, size = 44, radius = 8, fontSize = 20 }) {
  if (merit.img) {
    return (
      <img
        src={sourceImage(merit.img)}
        alt={merit.titulo}
        style={{
          width: size,
          height: size,
          borderRadius: radius,
          objectFit: "cover",
          display: "block",
        }}
      />
    );
  }
  const iconName = resolveMeritIconName(merit);
  const explicit = String(merit?.icone || "").trim();
  return (
    <div
      style={{
        width: size,
        height: size,
        borderRadius: radius,
        background: "transparent",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        color: merit.cor || "#4FB3A9",
        fontSize,
        lineHeight: 1,
      }}
    >
      <MeritGlyph name={iconName} customText={explicit || "*"} />
    </div>
  );
}
export default function Perfil(props) {
  var aulas;
  var modulos;
  let currentStudent = props.currentStudent;
  let viewingStudent = props.viewingStudent;
  let students = props.students;
  let houses = props.houses;
  let teachers = props.teachers;
  let checkpoints = props.checkpoints;
  let checkpointsComAutomaticos = props.checkpointsComAutomaticos;
  let activities = props.activities;
  let batalhas = props.batalhas;
  let conteudos = props.conteudos;
  let setConteudosNavigationTarget = props.setConteudosNavigationTarget;
  let goto = props.goto;
  let setStudents = props.setStudents;
  let showFlash = props.showFlash;
  let editingProfile = props.editingProfile;
  let setEditingProfile = props.setEditingProfile;
  let getPontosRank = props.getPontosRank;
  let getTokensGanhos = props.getTokensGanhos;
  let getTokensDisponiveis = props.getTokensDisponiveis;
  const [periodo, setPeriodo] = useState("semana");
  const aluno = viewingStudent
    ? students.find((student) => student.id === viewingStudent)
    : currentStudent;
  const isOwn = currentStudent && aluno && currentStudent.id === aluno.id;
  const profileSummary = useProfileSummary(aluno ? aluno.id : null);
  const profileBonus = useTaskBonusTotals(
    !!aluno,
    aluno ? aluno.id : null,
    getTaskBonusPeriod(periodo).from,
    getTaskBonusPeriod(periodo).to,
    showFlash,
  );
  const filtrarPorPeriodo = useCallback(
    (lista) => {
      if (!aluno) return [];
      const todos = lista.filter(
        (listaAluno_id) => listaAluno_id.aluno_id === aluno.id,
      );
      const hoje = todayISO();
      const semana = iniSemana();
      const mes = iniMes();
      const ano = new Date(Date.now() - 31536e6).toISOString().slice(0, 10);
      return todos
        .filter((todo) =>
          "hoje" === periodo
            ? todo.data_estudo === hoje
            : "semana" === periodo
              ? todo.data_estudo >= semana
              : "mes" === periodo
                ? todo.data_estudo >= mes
                : "ano" !== periodo || todo.data_estudo >= ano,
        )
        .sort((left, right) => right.criado_em - left.criado_em);
    },
    [aluno, periodo],
  );
  const cpFiltrados = useMemo(
    () => filtrarPorPeriodo(checkpoints),
    [checkpoints, filtrarPorPeriodo],
  );
  const cpFiltradosComAutomaticos = useMemo(
    () => filtrarPorPeriodo(checkpointsComAutomaticos || checkpoints),
    [checkpointsComAutomaticos, checkpoints, filtrarPorPeriodo],
  );
  const stats = useMemo(() => {
    const mapa = {};
    let horas = 0;
    let questoes = 0;
    cpFiltrados
      .filter((cpFiltrado) => "invalido" !== cpFiltrado.status_questao)
      .forEach((item) => {
        item.itens.forEach((iten) => {
          const quantidade = Number(iten.quantidade || 0);
          mapa[iten.tipo_id] = (mapa[iten.tipo_id] || 0) + quantidade;
          const atividade = activities.find(
            (activity) => activity.id === iten.tipo_id,
          );
          if ("hora" === atividade?.unidade) {
            horas += quantidade;
          }
          if ("questao" === atividade?.unidade) {
            questoes += quantidade;
          }
        });
      });
    return {
      por: mapa,
      horas,
      questoes,
    };
  }, [cpFiltrados, activities]);
  const totalRank =
    cpFiltradosComAutomaticos
      .filter(
        (cpFiltradosComAutomatico) =>
          "invalido" !== cpFiltradosComAutomatico.status_questao,
      )
      .reduce((sum, item) => sum + Number(item.pontos_rank || 0), 0) +
    (aluno ? profileBonus.points[Number(aluno.id)] || 0 : 0);
  const totalToken = cpFiltradosComAutomaticos
    .filter(
      (cpFiltradosComAutomatico) =>
        "invalido" !== cpFiltradosComAutomatico.status_questao,
    )
    .reduce((sum, item) => sum + Number(item.tokens || 0), 0);
  const conquistados = (
    aluno
      ? ProfileBadges(
          aluno.id,
          checkpoints,
          batalhas,
          props.meritos,
          activities,
          checkpointsComAutomaticos,
          profileSummary.data,
        )
      : []
  ).filter((item) => item.conquistado);
  if (!aluno)
    return (
      <div className={"ct"}>
        <div className={"es"}>
          <h3>{"Aluno não encontrado"}</h3>
        </div>
      </div>
    );
  if (editingProfile && isOwn)
    return (
      <PerfilEdit
        aluno={aluno}
        setStudents={setStudents}
        students={students}
        houses={houses}
        teachers={teachers}
        showFlash={showFlash}
        setEditingProfile={setEditingProfile}
      />
    );
  const casa = houses.find((house) => house.id === aluno.casa_id);
  const prof = teachers.find((teacher) => teacher.id === aluno.professor_id);
  const saldo =
    aluno.id === currentStudent?.id
      ? Number(getTokensDisponiveis(aluno.id) || 0)
      : null;
  const rankTotal = Number(getPontosRank(aluno.id) || 0);
  const studentKey = String(aluno.id);
  const progressoConteudos = conteudos?.progresso?.[studentKey] || {};
  const totalAulasConteudo = conteudos?.aulas?.length || 0;
  const concluidasConteudo = (conteudos?.aulas || []).filter((item) =>
    isAulaConcluida(progressoConteudos, item),
  ).length;
  const percentualConteudos = totalAulasConteudo
    ? Math.round((concluidasConteudo / totalAulasConteudo) * 100)
    : 0;
  const proximaAulaConteudo =
    (null === conteudos ||
    undefined === conteudos ||
    null === (aulas = conteudos.aulas) ||
    undefined === aulas
      ? undefined
      : aulas.find((item) => !isAulaConcluida(progressoConteudos, item))) ||
    conteudos?.aulas?.[0] ||
    null;
  const moduloProximaAula = proximaAulaConteudo
    ? null === conteudos ||
      undefined === conteudos ||
      null === (modulos = conteudos.modulos) ||
      undefined === modulos
      ? undefined
      : modulos.find((item) => item.id === proximaAulaConteudo.modulo_id)
    : null;
  getTokensGanhos(aluno.id);
  return (
    <div className={"cn"}>
      <div className={"ph"}>
        <div
          className={"pa"}
          style={
            aluno.foto
              ? {
                  backgroundImage: "url(".concat(sourceImage(aluno.foto), ")"),
                }
              : {}
          }
        >
          {!aluno.foto && DefaultAvatar()}
        </div>
        <div
          style={{
            flex: 1,
            minWidth: 0,
          }}
        >
          <div className={"pn"}>{aluno.nome}</div>
          <div className={"pm"}>
            {casa && (
              <span
                style={{
                  color: casa.cor,
                  fontWeight: 700,
                }}
              >
                {casa.nome}
              </span>
            )}
            {prof && (
              <span>
                {"prof. "}
                {prof.nome}
              </span>
            )}
            {aluno.escola && <span>{aluno.escola}</span>}
            {aluno.ano && <span>{aluno.ano}</span>}
          </div>
          {aluno.objetivo && (
            <div className={"po"}>
              {"Objetivo: "}
              {aluno.objetivo}
            </div>
          )}
          {aluno.bio && (
            <div
              style={{
                marginTop: 8,
                color: "#6B8590",
                fontStyle: "italic",
                fontSize: 12.5,
              }}
            >
              {'"'}
              {aluno.bio}
              {'"'}
            </div>
          )}
          <ProfileBalances points={rankTotal} tokens={saldo} own={isOwn} />
          {conquistados.length > 0 && (
            <div
              style={{
                marginTop: 8,
                display: "flex",
                gap: 4,
                flexWrap: "wrap",
              }}
            >
              {conquistados.map((conquistado) => (
                <span
                  className={"dm-profile-badge"}
                  title={conquistado.titulo + " — " + conquistado.desc}
                  aria-label={conquistado.titulo}
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: 2,
                  }}
                  key={conquistado.id}
                >
                  <MeritIcon
                    merit={conquistado}
                    size={32}
                    radius={4}
                    fontSize={24}
                  />
                </span>
              ))}
            </div>
          )}
        </div>
        {isOwn && (
          <button
            className={"btn bor bs"}
            onClick={() => setEditingProfile(true)}
            style={{
              flexShrink: 0,
              display: "flex",
              alignItems: "center",
              gap: 5,
            }}
          >
            <svg
              width={"13"}
              height={"13"}
              viewBox={"0 0 24 24"}
              fill={"none"}
              stroke={"currentColor"}
              strokeWidth={"2.5"}
              strokeLinecap={"round"}
            >
              <path
                d={"M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"}
              />
              <path
                d={"M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"}
              />
            </svg>
            {"Editar perfil"}
          </button>
        )}
      </div>
      <ProfileStats
        studentId={aluno.id}
        checkpoints={checkpointsComAutomaticos || checkpoints}
        activities={activities}
        summary={profileSummary}
      />
      {isOwn && totalAulasConteudo > 0 && (
        <div
          style={{
            background: "linear-gradient(135deg,#153543,#275767)",
            borderRadius: 14,
            padding: 16,
            marginBottom: 16,
            boxShadow: "0 8px 20px rgba(0,0,0,.14)",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              gap: 12,
              alignItems: "flex-start",
              marginBottom: 12,
            }}
          >
            <div>
              <div
                style={{
                  fontSize: 10,
                  color: "rgba(255,255,255,.55)",
                  fontWeight: 800,
                  textTransform: "uppercase",
                  letterSpacing: ".12em",
                  marginBottom: 6,
                }}
              >
                {"Conteúdos"}
              </div>
              <div
                style={{
                  fontSize: 20,
                  lineHeight: 1.15,
                  fontWeight: 900,
                  color: "#FFF",
                }}
              >
                {concluidasConteudo}
                {"/"}
                {totalAulasConteudo}
                {" aulas concluídas"}
              </div>
              <div
                style={{
                  marginTop: 6,
                  color: "rgba(255,255,255,.65)",
                  fontSize: 12,
                }}
              >
                {proximaAulaConteudo
                  ? "Proxima aula: ".concat(proximaAulaConteudo.titulo)
                  : "Nenhuma aula disponivel no momento."}
              </div>
            </div>
            <div
              style={{
                background: "rgba(79,179,169,.18)",
                borderRadius: 999,
                padding: "6px 12px",
                color: "#D7FBF5",
                fontSize: 12,
                fontWeight: 900,
                flexShrink: 0,
              }}
            >
              {percentualConteudos}
              {"%"}
            </div>
          </div>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit,minmax(120px,1fr))",
              gap: 8,
              marginBottom: 12,
            }}
          >
            {[
              {
                label: "Turmas",
                value: conteudos?.categorias?.length || 0,
              },
              {
                label: "Cursos",
                value: conteudos?.cursos?.length || 0,
              },
              {
                label: "Aulas",
                value: totalAulasConteudo,
              },
            ].map((item) => (
              <div
                style={{
                  background: "rgba(255,255,255,.08)",
                  border: "1px solid rgba(255,255,255,.12)",
                  borderRadius: 12,
                  padding: "10px 12px",
                }}
                key={item.label}
              >
                <div
                  style={{
                    fontSize: 10,
                    color: "rgba(255,255,255,.54)",
                    fontWeight: 800,
                    textTransform: "uppercase",
                    letterSpacing: ".08em",
                  }}
                >
                  {item.label}
                </div>
                <div
                  style={{
                    fontSize: 18,
                    color: "#FFF",
                    fontWeight: 900,
                    marginTop: 4,
                  }}
                >
                  {item.value}
                </div>
              </div>
            ))}
          </div>
          <div
            style={{
              height: 6,
              background: "rgba(255,255,255,.12)",
              borderRadius: 999,
              overflow: "hidden",
              marginBottom: 12,
            }}
          >
            <div
              style={{
                height: "100%",
                width: "".concat(percentualConteudos, "%"),
                background: "#4FB3A9",
                borderRadius: 999,
              }}
            />
          </div>
          <div
            style={{
              display: "flex",
              gap: 8,
              flexWrap: "wrap",
            }}
          >
            <button className={"btn"} onClick={() => goto("conteudos")}>
              {"Abrir conteudos"}
            </button>
            {proximaAulaConteudo && moduloProximaAula?.curso_id && (
              <button
                className={"btn bg bs"}
                onClick={() => {
                  if (
                    !(
                      null === setConteudosNavigationTarget ||
                      undefined === setConteudosNavigationTarget
                    )
                  ) {
                    setConteudosNavigationTarget({
                      cursoId: moduloProximaAula.curso_id,
                      aulaId: proximaAulaConteudo.id,
                    });
                  }
                  goto("conteudos");
                }}
              >
                {"Retomar aula"}
              </button>
            )}
          </div>
        </div>
      )}
      {conquistados.length > 0 && (
        <React.Fragment>
          <div className={"dv dv-dark"}>
            <span>
              {"Insígnias ("}
              {conquistados.length}
              {")"}
            </span>
          </div>
          <div
            className={"meritos-grid"}
            style={{
              marginBottom: 16,
            }}
          >
            {conquistados.map((conquistado) => {
              const iconColor = conquistado.cor || "#4FB3A9";
              const iconName = resolveMeritIconName(conquistado);
              const explicit = String(conquistado.icone || "").trim();
              return (
                <div className={"merito-card conquistado"} key={conquistado.id}>
                  {conquistado.img ? (
                    <img
                      src={sourceImage(conquistado.img)}
                      alt={conquistado.titulo}
                      style={{
                        width: 56,
                        height: 56,
                        borderRadius: 8,
                        objectFit: "cover",
                        margin: "0 auto 6px",
                        display: "block",
                      }}
                    />
                  ) : (
                    <div
                      style={{
                        width: 56,
                        height: 56,
                        borderRadius: 12,
                        background: "rgba(255,255,255,0.7)",
                        margin: "0 auto 10px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: 32,
                        color: iconColor,
                      }}
                    >
                      <MeritGlyph
                        name={iconName}
                        customText={explicit || "*"}
                      />
                    </div>
                  )}
                  <div
                    className={"merito-titulo"}
                    style={{
                      color: "#1F4754",
                    }}
                  >
                    {conquistado.titulo}
                  </div>
                  <div className={"merito-desc"}>{conquistado.desc}</div>
                  <div className={"merito-prog"}>
                    <div
                      className={"merito-prog-fill"}
                      style={{
                        width: "100%",
                      }}
                    />
                  </div>
                </div>
              );
            })}
          </div>
        </React.Fragment>
      )}
      <div
        className={"fi"}
        style={{
          marginBottom: 12,
        }}
      >
        <span className={"fl"}>{"Período"}</span>
        <select
          className={"sel"}
          value={periodo}
          onChange={(event) => setPeriodo(event.target.value)}
        >
          <option value={"hoje"}>{"Hoje"}</option>
          <option value={"semana"}>{"Semana"}</option>
          <option value={"mes"}>{"Mês"}</option>
          <option value={"ano"}>{"Ano"}</option>
          <option value={"tudo"}>{"Tudo"}</option>
        </select>
        <span
          style={{
            fontSize: 11,
            color: "#6B8590",
            fontWeight: 700,
            marginLeft: 4,
          }}
        >
          {fmtNum(totalRank)}
          {" pts rank | "}
          {fmtNum(totalToken)}
          {" tokens"}
        </span>
      </div>
      {Object.keys(stats.por).length > 0 && (
        <div
          className={"al"}
          style={{
            marginBottom: 14,
          }}
        >
          {activities
            .filter((activity) => stats.por[activity.id])
            .sort((left, right) => stats.por[right.id] - stats.por[left.id])
            .map((item) => (
              <div
                className={"ai"}
                style={{
                  borderLeftColor: item.cor,
                }}
                key={item.id}
              >
                <div>
                  <div className={"ail"}>{item.nome}</div>
                  <div className={"aiq"}>{"acumulado no período"}</div>
                </div>
                <div className={"aip"}>
                  <div className={"rank"}>
                    {fmtNum(stats.por[item.id], 1)}
                    <small>
                      {item.unidade}
                      {"s"}
                    </small>
                  </div>
                </div>
              </div>
            ))}
        </div>
      )}
      <div className={"dv dv-dark"}>
        <span>
          {"Histórico ("}
          {cpFiltrados.length}
          {")"}
        </span>
      </div>
      {0 === cpFiltrados.length ? (
        <p
          style={{
            color: "rgba(255,255,255,0.55)",
            textAlign: "center",
            padding: 14,
            fontStyle: "italic",
          }}
        >
          {"Sem registros nesse período."}
        </p>
      ) : (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: 6,
          }}
        >
          {cpFiltrados.map((cpFiltrado) => (
            <div
              className={"card"}
              style={{
                padding: 12,
                opacity: "invalido" === cpFiltrado.status_questao ? 0.5 : 1,
              }}
              key={cpFiltrado.id}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "flex-start",
                  marginBottom: cpFiltrado.observacao ? 6 : 0,
                }}
              >
                <div>
                  <div
                    style={{
                      fontSize: 13,
                      fontWeight: 700,
                    }}
                  >
                    {fmtDate(cpFiltrado.data_estudo)}
                  </div>
                  <div
                    style={{
                      fontSize: 11,
                      color: "#6B8590",
                      marginTop: 2,
                    }}
                  >
                    {cpFiltrado.itens.length}
                    {" atividade"}
                    {cpFiltrado.itens.length > 1 ? "s" : ""}
                    {"pendente" === cpFiltrado.status_questao
                      ? " - Em analise"
                      : "invalido" === cpFiltrado.status_questao
                        ? " - Invalidado"
                        : ""}
                  </div>
                </div>
                <div
                  style={{
                    textAlign: "right",
                  }}
                >
                  <div
                    style={{
                      fontSize: 16,
                      fontWeight: 800,
                      color: "#FF8C42",
                    }}
                  >
                    {fmtNum(cpFiltrado.pontos_rank || 0)}{" "}
                    <small
                      style={{
                        fontSize: 8,
                        color: "#6B8590",
                        fontWeight: 600,
                        textTransform: "uppercase",
                      }}
                    >
                      {"pts"}
                    </small>
                  </div>
                  <div
                    style={{
                      fontSize: 13,
                      fontWeight: 700,
                      color: "#4FB3A9",
                    }}
                  >
                    {fmtNum(cpFiltrado.tokens || 0)}{" "}
                    <small
                      style={{
                        fontSize: 8,
                        color: "#6B8590",
                        fontWeight: 600,
                        textTransform: "uppercase",
                      }}
                    >
                      {"tok"}
                    </small>
                  </div>
                </div>
              </div>
              {cpFiltrado.observacao && (
                <div
                  style={{
                    fontSize: 11,
                    color: "#6B8590",
                    fontStyle: "italic",
                    borderTop: "1px solid #F0F4F6",
                    paddingTop: 5,
                    marginTop: 4,
                  }}
                >
                  {'"'}
                  {cpFiltrado.observacao}
                  {'"'}
                </div>
              )}
            </div>
          ))}
        </div>
      )}
      {!isOwn && (
        <p
          style={{
            marginTop: 16,
          }}
        >
          <button className={"btn bg bs"} onClick={() => goto("feed")}>
            {"Voltar ao feed"}
          </button>
        </p>
      )}
    </div>
  );
}
function PerfilEdit(props) {
  let aluno = props.aluno;
  let setStudents = props.setStudents;
  let students = props.students;
  let houses = props.houses;
  let teachers = props.teachers;
  let showFlash = props.showFlash;
  let setEditingProfile = props.setEditingProfile;
  const [form, setForm] = useState({
    ...aluno,
    senha: "",
  });
  const [foto, setFoto] = useState(aluno.foto || null);
  return (
    <div className={"cn"}>
      <h1 className={"pt"}>
        <em>{"Editar"}</em>
        {" Perfil"}
      </h1>
      <form
        onSubmit={async (event) => {
          event.preventDefault();
          if (form.nome.trim())
            try {
              const payload = {
                ...form,
                foto: await saveProfilePhoto(aluno.id, foto),
              };
              const responseData2 = await api.put("/students/self", payload);
              const saved = responseData2.data?.data ?? responseData2.data;
              setStudents(
                students.map((student) =>
                  student.id === aluno.id ? saved : student,
                ),
              );
              showFlash("Perfil atualizado!");
              setEditingProfile(false);
            } catch (err) {
              showFlash(
                err.response?.data?.message ||
                  "Nao foi possivel atualizar o perfil agora.",
                "er",
              );
            }
          else showFlash("Nome obrigatório.", "er");
        }}
        className={"fc"}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 13,
            marginBottom: 16,
          }}
        >
          <div
            className={"pa"}
            style={{
              width: 66,
              height: 66,
              fontSize: 24,
              ...(foto
                ? {
                    backgroundImage: "url(".concat(sourceImage(foto), ")"),
                  }
                : {}),
            }}
          >
            {!foto && DefaultAvatar()}
          </div>
          <div
            style={{
              flex: 1,
            }}
          >
            <label
              style={{
                fontSize: 12,
                fontWeight: 700,
                color: "#1F4754",
                display: "block",
                marginBottom: 5,
              }}
            >
              {"Foto"}
            </label>
            <input
              type={"file"}
              accept={"image/*"}
              onChange={(event) => {
                const file = event.target.files[0];
                if (!file) return;
                const reader = new FileReader();
                reader.onload = (eventTarget) =>
                  setFoto(eventTarget.target.result);
                reader.readAsDataURL(file);
              }}
              className={"inp"}
            />
          </div>
        </div>
        <ProfileAvatarPicker value={foto} onChange={setFoto} />
        <div className={"fg"}>
          <label>{"Nome completo *"}</label>
          <input
            className={"inp"}
            value={form.nome}
            onChange={(event) =>
              setForm({
                ...form,
                nome: event.target.value,
              })
            }
            required={true}
          />
        </div>
        <div className={"fr"}>
          <div className={"fg"}>
            <label>{"E-mail *"}</label>
            <input
              className={"inp"}
              value={form.usuario}
              onChange={(event) =>
                setForm({
                  ...form,
                  usuario: event.target.value.toLowerCase().replace(/\s+/g, ""),
                })
              }
              required={true}
            />
          </div>
          <div className={"fg"}>
            <label>{"Senha"}</label>
            <input
              type={"password"}
              minLength={6}
              maxLength={72}
              className={"inp"}
              value={form.senha}
              onChange={(event) =>
                setForm({
                  ...form,
                  senha: event.target.value,
                })
              }
              placeholder={"Deixe vazio para manter; mínimo de 6 caracteres"}
            />
          </div>
        </div>
        <div className={"fr"}>
          <div className={"fg"}>
            <label>{"Instituição"}</label>
            <input
              className={"inp"}
              readOnly={true}
              value={
                (
                  houses.find(
                    (house) => Number(house.id) === Number(aluno.casa_id),
                  ) || {}
                ).nome || "Instituição vinculada"
              }
              aria-label={"Instituição vinculada"}
            />
          </div>
        </div>
        <div className={"fr"}>
          <div className={"fg"}>
            <label>{"Escola"}</label>
            <input
              className={"inp"}
              value={form.escola || ""}
              onChange={(event) =>
                setForm({
                  ...form,
                  escola: event.target.value,
                })
              }
            />
          </div>
          <div className={"fg"}>
            <label>{"Ano"}</label>
            <select
              className={"sel"}
              value={form.ano || ""}
              onChange={(event) =>
                setForm({
                  ...form,
                  ano: event.target.value,
                })
              }
            >
              <option value={""}>{"-"}</option>
              {ANOS.map((ano) => (
                <option value={ano} key={ano}>
                  {ano}
                </option>
              ))}
            </select>
          </div>
        </div>
        <div className={"fg"}>
          <label>{"Objetivo"}</label>
          <input
            className={"inp"}
            value={form.objetivo || ""}
            onChange={(event) =>
              setForm({
                ...form,
                objetivo: event.target.value,
              })
            }
            placeholder={"Ex: Medicina USP"}
          />
        </div>
        <div className={"fg"}>
          <label>{"Telefone"}</label>
          <input
            className={"inp"}
            value={form.telefone || ""}
            onChange={(event) =>
              setForm({
                ...form,
                telefone: event.target.value,
              })
            }
          />
        </div>
        <div className={"fg"}>
          <label>{"Bio / Motivação"}</label>
          <textarea
            className={"tea"}
            value={form.bio || ""}
            onChange={(event) =>
              setForm({
                ...form,
                bio: event.target.value,
              })
            }
          />
        </div>
        <div
          style={{
            display: "flex",
            gap: 8,
            marginTop: 14,
          }}
        >
          <button type={"submit"} className={"btn"}>
            {"Salvar"}
          </button>
          <button
            type={"button"}
            className={"btn bg"}
            onClick={() => setEditingProfile(false)}
          >
            {"Cancelar"}
          </button>
        </div>
      </form>
    </div>
  );
}
export { MeritIcon };
